import React from 'react';
import BranchesTab from './tabs';

export default function Branches() {
    return (
        <div>
            <BranchesTab />
        </div>
    );
}
